import { ref, computed } from 'vue-demi';
import { CHILD_MODAL } from '../common/constant';


export default (props) => {
    const visible = ref(false);
    const showModal = () => {
        visible.value = true;
    };

    const modalStatus = ref();
    const setModalStatus = (status) => {
        modalStatus.value = status;
        showModal();
    };

    const modal = computed(() => {
        const children = props.tpl.children.filter((item) => {
            return item.type === CHILD_MODAL && item.props.status === modalStatus.value;
        });
        return children.length ? children : null;
    });

    return {
        modal,
        modalStatus,
        setModalStatus,
        visible,
    };
};
